export default class Link {

    static onWindowOpen(href: string): void {
        window.open(href);
    }

    static onMailTo(mail: string): void {
        window.open(`mailto:${mail}`)
    }

    static onPhoneTo(phone: string): void {
        window.open(`tel:${phone}`)
    }
}